module.exports = __webpack_public_path__ + "static/media/video.f59a7674.png";